function customInit(section) {
  document.querySelectorAll(`.collection-slider[data-section="${section}"] .slider-container`).forEach(slider => {
    let mySwiper = new Swiper(slider, {
      speed: 500,
      spaceBetween: 20,
      slidesPerView: 4,
      direction: 'horizontal',
      navigation: {
        nextEl: `#button-next-count-${slider.dataset.slider}`,
        prevEl: `#button-prev-count-${slider.dataset.slider}`
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          slidesOffsetBefore: 0
        },
        767: {
          slidesPerView: 2,
          slidesOffsetBefore: 0
        },
        1200: {
          slidesPerView: 4
        }
      }
    })
    if (slider.classList.contains('active')) {
      mySwiper.init()
    } else {
      mySwiper.destroy()
    }
  })
}
function respProduct(res, section){
  var arr_color = [];
  var images_src = {};
  var variant_valid = {}
  var position_color_option = null;
  res.options.filter(function (element) {
    if (element.name == 'Color') {
      position_color_option = element.position
    }
    return element.name == 'Color';
  }).forEach(item => arr_color = arr_color.concat(item.values))
  arr_color.forEach(item => {
    var current_variant = res.variants.filter(variant => variant['option' + position_color_option] == item)[0];
    if (current_variant) {
      if (current_variant.featured_image && current_variant.featured_image.id) {
        var current_image = res.images.filter(image => image.id === current_variant.featured_image.id);
        if (current_image) {
          variant_valid[item] = current_variant.available;
          images_src[item] = current_variant.featured_image.src;
        }
      }
    }
  });

  const validIndex = arr_color.findIndex((item) => variant_valid[item]);
  document.querySelector(`${section} .variant-result[data-variant-id="${res.id}"] .variant-container`).innerHTML =
    arr_color.map((item, index) =>
      `<div class="color-swatch ${variant_valid[item] && index === validIndex ? 'active' : ''}"
        data-variant-color="${item.toLowerCase()}"
        data-variant-src="${images_src[item]}"
        data-variant-available="${variant_valid[item]}">
        <div class="swatch">
          <span class="color1"></span>
          <span class="color2"></span>
          <span class="color3"></span>
        </div>
      </div>`
    ).join('');
}
function createSectionTabSlider(section, product){
  if (document.querySelector(`${section}`) != null) {
    const allSlides = document.querySelectorAll(`${section} ${product}`);
    allSlides.forEach(elem => {
      if (!elem) return
      return fetch(`/products/${elem.dataset.prodHandle}.js`)
        .then(res => res.json())
        .then(
            res => {
              respProduct(res, section)
            }
        ).catch(error => {
          console.error(error);
        });
    })
  }
}
